'use strict';

const FORM_SELECTOR_MOBILE = '.date-picker';
const FORM_SELECTOR_DESKTOP = '.date-picker__desktop';

const RADIO_SELECTOR_MOBILE = '.date-picker .date-picker__radio';

const CHECKED_RADIO = 'input[type = radio]:checked'
const MOBILE_BUTTON = '.date-picker .date-picker__btn';
const DESKTOP_BUTTON = '.date-picker__inner-desktop'

export function init() {
    const form_mobile = document.querySelector(FORM_SELECTOR_MOBILE);
    const options_mobile = document.querySelectorAll(RADIO_SELECTOR_MOBILE);
    const form_desktop = document.querySelector(FORM_SELECTOR_DESKTOP);
    const mobile_button = document.querySelector(MOBILE_BUTTON);

    if (form_mobile !== null) {
        for (const option of options_mobile) {
            option.addEventListener('change', e => {
                mobile_button.textContent = e.target.dataset.customBookingLabel ?? 'Buy Tickets';
                mobile_button.disabled = false;
            });
        }

        form_mobile.addEventListener('submit', e => {
            e.preventDefault()
            let performanceId = null
            let customBookingURL = null

            const radio_mobile = form_mobile.querySelector(CHECKED_RADIO); // Get checked radio button

            if (radio_mobile !== null) {
                performanceId = radio_mobile.value;
                customBookingURL = radio_mobile.dataset.customBookingLink;
            }

            if (customBookingURL) {
                window.location = customBookingURL;
            } else {
                window.location = `${AppConfig.boDomain}booking/production/${performanceId}`;
            }
        })
    }

    if (form_desktop !== null) {
        form_desktop.addEventListener('submit', e => {
            e.preventDefault()
            let performanceId = null;
            let customBookingURL = null;

            if (e.submitter !== null) {
                performanceId = e.submitter.value;
                customBookingURL = e.submitter.dataset.customBookingLink;
            }

            if (customBookingURL) {
                window.location = customBookingURL;
            } else {
                window.location = `${AppConfig.boDomain}booking/production/${performanceId}`;
            }
        })
    }
}
